<script>
  import formatDate from '@utils/format-date'

  export default {
    props: {
      data: {
        type: Object,
        required: true
      },
    },
    data() {
      return {
        formatDate,
        visibleVideoDialog: false
      }
    },
    methods: {
      formatLink() {
        return {
          name: 'brand-video-item',
          params: {
            videoAlias: 'videoAlias',
            brandAlias: 'test'
          }
        }
      },
      playVideo() {
        this.$refs.youtube.player.playVideo()
      },
      stopVideo() {
        this.$refs.youtube.player.stopVideo()
      },
      getId() {
        // return this.$youtube.getIdFromUrl(this.video.url)
      },
      onPlay(id) {
        this.visibleVideoDialog = true
        this.$nextTick(() => {
          this.$emit('play', id)
        })
      },
    }
  }
</script>
<template>
  <div :class="$style.listVideoItem">
    <div
      class="listVideoItem__video"
      @click="onPlay(data.videoId)"
    >
      <!--          <div class="listVideoItem__videoIcon">
                    <i class="fas fa-play"></i>
                </div>-->
      <youtube
        ref="youtube"
        :video-id="data.videoId"
        class="listVideoItem__youtube"
      ></youtube>
    </div>
    <div class="listVideoItem__content">
      <div class="d-flex mb-md-3 mb-2 align-items-center justify-content-between">
        <div :class="$style.brandList">
          <div class="brandList__item">
            <router-link
              :to="{ name: 'brand-item', params: { brandAlias: data.to.params.brandAlias } }"
              class="brandList__link"
            >
              <img
                :src="data.brands.logo_image"
                alt=""
                class="brandList__logo"/>
            </router-link>
          </div>
        </div>
        <div class="listVideoItem__date">
          <i class="far fa-clock"></i>
          {{ formatDate(data.publish_up) }}
        </div>
      </div>
      <div class="listVideoItem__title">
        {{ data.title }}
      </div>
      <router-link
        class="listVideoItem__link"
        :to="data.to"
      ></router-link>
      <el-tag v-if="data.top" class="listVideoItem__top isStylePrimary isOutline isAngle">置頂</el-tag>
    </div>
  </div>
</template>
<style lang="scss" module>
  .listVideoItem {
    &:hover {
      :global {
        .listVideoItem {
          &__title {
            color: $color-primary;
          }
        }
      }
    }

    :global {
      .listVideoItem {
        &__video {
          position: relative;
          z-index: 0;
          padding-top: 56%;
          cursor: pointer;
          background: #EEE;
          background-position: center;
          background-size: cover;

          /* &:before {
              content: '';
              position: absolute;
              left: 0;
              right: 0;
              top: 0;
              bottom: 0;
              z-index: -1;
              background: rgba(#000, 0.5);
              transition: background 0.3s;
          }
          &:hover {
              &:before {
                  background: rgba(#000, 0.65);
              }
          } */
        }

        &__youtube {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        }

        &__videoIcon {
          position: absolute;
          top: 50%;
          left: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 75px;
          height: 75px;
          padding-right: 4px;
          padding-left: 13px;
          font-size: 30px;
          color: #FFF;
          text-align: center;
          background: 0 0;
          border: 1px solid #FFF;
          border-radius: 100%;
          transform: translate(-50%, -50%);
          -webkit-appearance: none;
          -moz-appearance: none;
          appearance: none;
        }

        &__content {
          position: relative;
          padding-top: 1.2rem;

          @include max-lg {
            padding-top: 1rem;
          }
        }

        &__title {
          font-size: 1.25rem;
          font-weight: 500;
          line-height: 1.5;

          @include line-clamp(3, 4.5em);

          @include max-lg {
            font-size: 1.125rem;
          }
        }

        &__date {
          font-size: 0.875rem;
          color: $color-gray-5;
        }

        &__link {
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
        }
        &__top {
          position: absolute;
          top: 48px;
          right: 3px;
          height: 28px;
          line-height: 28px;
        }
      }
    }
  }

  .brandList {
    display: flex;

    :global {
      .brandList {
        &__item {
          position: relative;
          z-index: 1;
          height: 40px;

          &:not(:last-child) {
            .brandList {
              &__link {
                border-right: 1px solid $color-gray-3;
              }
            }
          }

          &:first-child {
            .brandList {
              &__link {
                padding-left: 0;
              }
            }
          }
        }

        &__link {
          display: block;
          padding: 0 1.25rem;

          &:hover {
            opacity: 0.75;
          }
        }

        &__logo {
          max-height: 40px;
        }
      }
    }
  }
</style>
